export function splitItemsForOverflow<T>(
  items: T[],
  itemWidths: number[],
  availableWidth: number,
  overflowControlWidth: number,
  gap: number
): { visible: T[]; overflow: T[] } {
  if (
    items.length === 0 ||
    availableWidth <= 0 ||
    itemWidths.length !== items.length ||
    itemWidths.some((width) => width <= 0)
  ) {
    return { visible: items, overflow: [] }
  }

  const totalWidth =
    itemWidths.reduce((sum, width) => sum + width, 0) +
    gap * Math.max(0, items.length - 1)

  if (totalWidth <= availableWidth) {
    return { visible: items, overflow: [] }
  }

  let usedWidth = 0
  let visibleCount = 0

  for (let index = 0; index < items.length; index += 1) {
    const chipWidth = itemWidths[index] ?? 0
    const widthWithPrecedingGap = chipWidth + (visibleCount > 0 ? gap : 0)
    const overflowCost = gap + overflowControlWidth

    if (usedWidth + widthWithPrecedingGap + overflowCost > availableWidth) {
      break
    }

    usedWidth += widthWithPrecedingGap
    visibleCount += 1
  }

  return {
    visible: items.slice(0, visibleCount),
    overflow: items.slice(visibleCount),
  }
}
